import React, { useEffect, useState } from "react";
import { ApplicationsAPI } from "../../components/apis";

const UserInterfaceTokenGenerator = () => {
    const location = window.location;
    const code= new URLSearchParams(location.search).get("code");
    const application= JSON.parse(new URLSearchParams(location.search).get("state"));

    const [tokenValue, setTokenValue] = useState("");
        
    const appApi = new ApplicationsAPI();
      

    useEffect(() => {

        appApi.getToken({ ...application, code })
            .then(data => {
                setTokenValue(data && data.access_token);
            }).catch(err => {
                console.log(err);
            })
        
    }, []);

    return (
        (tokenValue === "")?
            <span id="idWithApplicationToken">
                The token could not be generated yet. Please try again in a few seconds
            </span>
        :
            <span id="idWithApplicationToken">
                {tokenValue}
            </span>
            
    )
}

export default UserInterfaceTokenGenerator;
